const createSessionStore = () => ({
  isAuthenticated: null as boolean | null,
  showWarning: false,
  warningTime: 0,
  sessionExpiry: 0,
  lastActivityTime: null as string | null,
  user: null as Record<string, unknown> | null,

  setIsAuthenticated(value: boolean) {
    this.isAuthenticated = value;
  },

  setShowWarning(value: boolean) {
    this.showWarning = value;
  },

  setWarningTime(value: number) {
    this.warningTime = value;
  },

  setSessionExpiry(value: number) {
    this.sessionExpiry = value;
  },

  setLastActivityTime(value: string | null) {
    this.lastActivityTime = value;
  },

  setUser(userData: Record<string, unknown> | null) {
    this.user = userData;
  },
});

export default createSessionStore;